import { useQuery, useQueryClient,useMutation } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { fetchBoardMember, updateBoardMember, createBoardMember, deleteBoardMember } from "../api/boardApi";


export const useBoardMember = () =>{
    const queryClient = useQueryClient();
    const { data: boardMembers, error, isLoading } = useQuery({
        queryKey: ["boardMembers"],
        queryFn: fetchBoardMember,
        onError: (error) => {
            toast.error(error.response?.data?.message || "Failed to fetch Board Members");
        }
    });

    const editBoardMemberMutation = useMutation({
        mutationFn:updateBoardMember,
        onSuccess: (data) => {
            toast.success(data.message || "updated successfully!");
            queryClient.invalidateQueries(
                ["boardMembers"]
            );
        },
        onError: (error) => {
            console.log("Update board member Mutation Error:", error);
            toast.error(error.response?.data.message || "Failed to update!");
        },
    })

    const createBoardMemberMutation = useMutation({
        mutationFn:createBoardMember,
        onSuccess: (data) => {
            toast.success(data.message || "Add member successfully!");
            queryClient.invalidateQueries(
                ["boardMembers"]
            );
        },
        onError: (error) => {
            console.log("create board member Mutation Error:", error.response?.data);
            toast.error(error.response?.data.message || "Failed to add member!");
        },
    })

    const deleteBoardMemberMutation = useMutation({
        mutationFn:deleteBoardMember,
        onSuccess: (data) => {
            toast.success(data.message || "delete member successfully!");
            queryClient.invalidateQueries(
                ["boardMembers"]
            );
        },
        onError: (error) => {
            console.log("delete board member Mutation Error:", error.response?.data);
            toast.error(error.response?.data.message || "Failed to delete member!");
        },
    })

    return {
        boardMembers,
        isLoading,
        error,
        updateBoard:editBoardMemberMutation.mutate,
        updateBoardLoading: editBoardMemberMutation.isPending,
        updateBoardSuccess: editBoardMemberMutation.isSuccess,
        createBoard:createBoardMemberMutation.mutate,
        createBoardLoading: createBoardMemberMutation.isPending,
        createBoardSuccess: createBoardMemberMutation.isSuccess,
        deleteBoard:deleteBoardMemberMutation.mutate,
        deleteBoardLoading: deleteBoardMemberMutation.isPending,
        deleteBoardSuccess: deleteBoardMemberMutation.isSuccess,
    }
}